import styled, { keyframes } from 'styled-components';

export const fadeOut = keyframes`
    from {
    opacity: 90%;
  }
    to {
    opacity: 0;
  }
`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  min-height: 662px;
  position: relative;
`;

export const FadeOverlay = styled.div`
  animation: ${fadeOut} 1.2s ease-in-out forwards;
  background: ${({ theme }) => theme.elsie.colors.inverse.surface.faint.default};
  inset: 0;
  pointer-events: none;
  position: absolute;
  z-index: 2;
`;

export const Content = styled.section`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: space-between;
  margin-top: 20px;
`;

export const TabDescription = styled.p`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.soft};
  font-size: ${({ theme }) => theme.elsie.fontSize.xs};
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;
